function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storeOrderDelivery, storeOrderDetail, storeOrderPage, storeOrderRemark, storeOrderStatusNum, storeOrderVerify } from '@/api/distributionStore';
export default {
  name: 'DistributionStoreOrder',
  data: function data() {
    return {
      loading: false,
      saving: false,
      rows: [],
      total: 0,
      counts: {},
      activeStatus: 'all',
      verifyVisible: false,
      deliveryVisible: false,
      remarkVisible: false,
      detailVisible: false,
      verifyCode: '',
      detail: null,
      actionForm: {
        orderNo: '',
        expressName: '',
        expressNo: '',
        remark: ''
      },
      query: {
        page: 1,
        limit: 20,
        keyword: '',
        status: null,
        deliveryType: null
      },
      tabs: [{
        label: '全部',
        value: 'all',
        countKey: 'all'
      }, {
        label: '待付款',
        value: '0',
        countKey: 'unpaid'
      }, {
        label: '待履约',
        value: '1',
        countKey: 'paid'
      }, {
        label: '已发货',
        value: '2',
        countKey: 'delivered'
      }, {
        label: '已完成',
        value: '3',
        countKey: 'finished'
      }, {
        label: '已取消',
        value: '4',
        countKey: 'cancelled'
      }]
    };
  },
  created: function created() {
    this.load();
    this.loadCounts();
  },
  methods: {
    load: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return storeOrderPage(this.query);
            case 2:
              res = _context.v;
              this.rows = res.records || [];
              this.total = Number(res.total || 0);
            case 3:
              _context.p = 3;
              this.loading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }(),
    loadCounts: function () {
      var _loadCounts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return storeOrderStatusNum();
            case 1:
              this.counts = _context2.v;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function loadCounts() {
        return _loadCounts.apply(this, arguments);
      }
      return loadCounts;
    }(),
    statusChange: function statusChange() {
      this.query.status = this.activeStatus === 'all' ? null : Number(this.activeStatus);
      this.query.page = 1;
      this.load();
    },
    pageChange: function pageChange(page) {
      this.query.page = page;
      this.load();
    },
    sizeChange: function sizeChange(limit) {
      this.query.limit = limit;
      this.query.page = 1;
      this.load();
    },
    openVerify: function openVerify() {
      this.verifyCode = '';
      this.verifyVisible = true;
    },
    verify: function () {
      var _verify = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (this.verifyCode) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, this.$message.warning('请输入核销码'));
            case 1:
              this.saving = true;
              _context3.p = 2;
              _context3.n = 3;
              return storeOrderVerify(this.verifyCode);
            case 3:
              this.$message.success('核销成功');
              this.verifyVisible = false;
              this.load();
              this.loadCounts();
            case 4:
              _context3.p = 4;
              this.saving = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[2,, 4, 5]]);
      }));
      function verify() {
        return _verify.apply(this, arguments);
      }
      return verify;
    }(),
    openDelivery: function openDelivery(row) {
      this.actionForm = {
        orderNo: row.orderNo,
        expressName: '',
        expressNo: '',
        remark: ''
      };
      this.deliveryVisible = true;
    },
    delivery: function () {
      var _delivery = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!(!this.actionForm.expressName || !this.actionForm.expressNo)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, this.$message.warning('请填写快递公司和单号'));
            case 1:
              this.saving = true;
              _context4.p = 2;
              _context4.n = 3;
              return storeOrderDelivery(this.actionForm);
            case 3:
              this.$message.success('发货成功');
              this.deliveryVisible = false;
              this.load();
              this.loadCounts();
            case 4:
              _context4.p = 4;
              this.saving = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[2,, 4, 5]]);
      }));
      function delivery() {
        return _delivery.apply(this, arguments);
      }
      return delivery;
    }(),
    openRemark: function openRemark(row) {
      this.actionForm = {
        orderNo: row.orderNo,
        remark: row.userRemark || ''
      };
      this.remarkVisible = true;
    },
    remark: function () {
      var _remark = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              this.saving = true;
              _context5.p = 1;
              _context5.n = 2;
              return storeOrderRemark(this.actionForm);
            case 2:
              this.$message.success('备注已保存');
              this.remarkVisible = false;
              this.load();
            case 3:
              _context5.p = 3;
              this.saving = false;
              return _context5.f(3);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[1,, 3, 4]]);
      }));
      function remark() {
        return _remark.apply(this, arguments);
      }
      return remark;
    }(),
    showDetail: function () {
      var _showDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return storeOrderDetail(row.orderNo);
            case 1:
              this.detail = _context6.v;
              this.detailVisible = true;
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function showDetail(_x) {
        return _showDetail.apply(this, arguments);
      }
      return showDetail;
    }()
  }
};